<template>
  <div class="content">
    <div class="quiz">
      <div class="status-bar">
        <RoundedLabel v-if="party.status" small>
          {{ currentQuestionLabel }}
        </RoundedLabel>
      </div>
      <div v-if="party.status" class="questions-container">
        <transition-group :name="transitionName">
          <!--  <Question key="eins" :question="quiz.questions[0]" /> -->
          <Question
            v-for="(question, index) in quiz.questions"
            v-show="index === party.currentQuestion"
            :key="question.id"
            :ref="'q' + index"
            :question="question"
            :locked="locked"
            :validate="party.currentQuestion === party.showResult"
            @change="onAnswerChange"
            @lock-answer="lockAnswer"
          />
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import Question from '@/components/Question';
import RoundedLabel from '@/components/RoundedLabel';
/* import Vue from 'vue'; */
import { partyDb, firebaseApp } from '@/firebase';
import { firebase } from '@firebase/app';
import PARTY_BY_CODE from '@/graphql/PartyByCode.gql';

export default {
  apollo: {
    quiz: {
      query: PARTY_BY_CODE,
      variables() {
        return {
          code: sessionStorage.getItem('party_participant_code')
        };
      },
      update: data => {
        return data.partyByCode.quiz;
      }
    }
  },
  components: {
    Question,
    RoundedLabel
  },
  data() {
    return {
      locked: false,
      party: false,
      partyCode: false,
      participantId: false,
      quiz: false,
      currentQuestionAnswer: false
    };
  },
  computed: {
    currentQuestionLabel() {
      let qLabel = '-/-';
      if (this.quiz.questions && this.party) {
        qLabel =
          parseInt(this.party.currentQuestion + 1) +
          '/' +
          this.quiz.questions.length;
      }
      return qLabel;
    },
    transitionName() {
      return this.party.currentQuestion ? 'slide' : 'fade';
    }
  },

  watch: {
    party(newP, oldP) {
      if (newP.status === 0) {
        this.$router.push({ name: 'ParticipantJoin' });
      } else if (newP.status === 2) {
        this.$router.push({ name: 'PartyEnd' });
      }
      if (newP.currentQuestion != oldP.currentQuestion) {
        this.locked = false;
        this.currentQuestionAnswer = false;
      }
    }
  },
  created: function() {
    const sessionCode = sessionStorage.getItem('party_participant_code');
    const sessionId = sessionStorage.getItem('party_participant_id');
    this.partyCode = sessionCode;
    this.participantId = sessionId;

    this.$binding('party', partyDb.collection('parties').doc(this.partyCode));
  },
  mounted() {
    firebaseApp.auth().onAuthStateChanged(user => {
      const uid = user.uid;
      // Kolla om användaren har laddat om sidan
      partyDb
        .doc('/participants/' + uid)
        .get()
        .then(doc => {
          const data = doc.data();
          if (
            data != undefined &&
            data.partyCode == undefined &&
            this.partyCode
          ) {
            // Uppdatera objektet
            partyDb.doc('/participants/' + uid).set(
              {
                partyCode: this.partyCode
              },
              { merge: true }
            );
          }
        });
    });
  },
  methods: {
    lockAnswer() {
      this.locked = true;
      const val = this.$refs['q' + this.party.currentQuestion][0].answerValue;
      //console.log('lockANswer', val);

      const uid = firebaseApp.auth().currentUser.uid;
      partyDb.doc('/participants/' + uid).set(
        {
          answers: firebase.firestore.FieldValue.arrayUnion({
            question: this.party.currentQuestion,
            value: val
          })
        },
        { merge: true }
      );
    },
    onAnswerChange(val) {
      this.currentQuestionAnswer = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-flow: row nowrap;

  padding: 0;
}

.status-bar {
  margin-top: 15px;
}
.questions-container {
  > span {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    max-width: $view-max-width;
    margin: 0 auto;

    > * {
      flex: 0 0 100%;
      width: 100%;
      padding: 0 $padding-h;
      &:first-child {
        &.slide-enter,
        &.slide-enter-to {
          transform: none !important;
        }
      }
    }
  }
}
.quiz {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: column nowrap;
  > * {
    flex-shrink: 0;
  }

  h1 {
    color: #fff;
    font-weight: 500;
    font-size: 30/14 * 1rem;
  }
}
.error {
  color: #ff1232;
  font-size: 14/14 * 1rem;
}

@media (min-height: 700px) {
  .status-bar {
    margin-top: 20px;
    margin-bottom: 10px;
  }
}
</style>
